const { Swiper } = require('swiper');
import { Autoplay, Navigation, Thumbs } from 'swiper/modules';

const heroSections = document.querySelectorAll('.hero');

if (heroSections.length) {
    Swiper.use([Autoplay, Navigation, Thumbs]);
    heroSections.forEach(element => {
        const sliderElement = element.querySelector('.js-hero-swiper');
        const thumbsSliderElement = element.querySelector(
            '.js-hero-thumbs-swiper'
        );

        let thumbsSwiper;

        if (thumbsSliderElement) {
            thumbsSwiper = new Swiper(thumbsSliderElement, {
                freeMode: true,
                watchSlidesProgress: true,
                breakpoints: {
                    0: {
                        slidesPerView: 2.5,
                        spaceBetween: 12,
                    },
                    991.98: {
                        slidesPerView: 6,
                        spaceBetween: 12,
                    },
                },
            });
        }

        const swiper = new Swiper(sliderElement, {
            // Efekt "peek" jak na x-kom: aktywny slajd ma stałą maks. szerokość
            // (ustawioną w SCSS na .hero__slide). Gdy viewport jest szerszy niż
            // ta szerokość (zoom <100% lub bardzo szeroki monitor) — z boków
            // wystają kawałki sąsiednich slajdów. Szerokość slajdu bierze się z CSS.
            slidesPerView: 'auto',
            centeredSlides: true,
            // rewind zamiast loop: loop w Swiperze 10.3 przy centeredSlides +
            // slidesPerView:'auto' + 3 slajdach realnie pomija środkowy slajd
            // (zweryfikowane: realIndex skakał 2→0→2→0, nigdy 1). rewind daje
            // cykliczne autoodtwarzanie 0→1→2→0 i poprawne strzałki, bez klonów.
            rewind: true,
            spaceBetween: 24,
            autoplay: {
                delay: 7000,
                disableOnInteraction: false,
            },
            navigation: {
                prevEl: sliderElement.querySelector('.-prev'),
                nextEl: sliderElement.querySelector('.-next'),
                disabledClass: '-disabled',
            },
            thumbs: {
                swiper: thumbsSwiper,
                slideThumbActiveClass: '-active',
            },
        });

        if (thumbsSliderElement && swiper.params?.autoplay?.delay) {
            thumbsSliderElement.style.setProperty(
                '--hero-bullet-duration',
                `${swiper.params.autoplay.delay}ms`
            );
        }

        const linkedSlides = sliderElement.querySelectorAll(
            '.hero__slide[data-slide-link]'
        );

        const handleSlideLinkNavigation = slide => {
            const url = slide.dataset.slideLink;
            if (!url) return;
            const target = slide.dataset.slideTarget || '_self';

            if (target === '_blank') {
                window.open(url, '_blank');
            } else {
                window.location.href = url;
            }
        };

        linkedSlides.forEach(slide => {
            slide.addEventListener('click', event => {
                if (event.target.closest('a, button')) {
                    return;
                }
                handleSlideLinkNavigation(slide);
            });

            slide.addEventListener('keydown', event => {
                if (event.key === 'Enter' || event.key === ' ') {
                    event.preventDefault();
                    handleSlideLinkNavigation(slide);
                }
            });
        });
    });
}
